module.exports = __webpack_public_path__ + "static/img/008.91ec6bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/008.png
// module id = yMYX
// module chunks = 0